import { render, staticRenderFns } from "./email.vue?vue&type=template&id=311f6b7e&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=311f6b7e&prod&lang=less"
import style1 from "./email.vue?vue&type=style&index=1&id=311f6b7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f6b7e",
  null
  
)

export default component.exports